module.exports = __webpack_public_path__ + "img/36070-3.prt.e4137f40.jpg";